import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { WizardProvider } from "@/components/WizardProvider";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import ServicePage from "@/pages/Services";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <BrowserRouter>
        <WizardProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/pillars/:slug" element={<ServicePage />} />
          </Routes>
        </WizardProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </ReactLenis>
  );
}

export default App;
